__turbopack_context__.v({
  "active": "MenuHeaderHero-module-scss-module__FQpgjG__active",
  "backgroundVideo": "MenuHeaderHero-module-scss-module__FQpgjG__backgroundVideo",
  "button": "MenuHeaderHero-module-scss-module__FQpgjG__button",
  "buttonGroup": "MenuHeaderHero-module-scss-module__FQpgjG__buttonGroup",
  "ctaButton": "MenuHeaderHero-module-scss-module__FQpgjG__ctaButton",
  "ctaButtons": "MenuHeaderHero-module-scss-module__FQpgjG__ctaButtons",
  "darkOverlay": "MenuHeaderHero-module-scss-module__FQpgjG__darkOverlay",
  "dash": "MenuHeaderHero-module-scss-module__FQpgjG__dash",
  "grillingBadge": "MenuHeaderHero-module-scss-module__FQpgjG__grillingBadge",
  "grillingImage": "MenuHeaderHero-module-scss-module__FQpgjG__grillingImage",
  "h1": "MenuHeaderHero-module-scss-module__FQpgjG__h1",
  "heroLogo": "MenuHeaderHero-module-scss-module__FQpgjG__heroLogo",
  "heroOverlay": "MenuHeaderHero-module-scss-module__FQpgjG__heroOverlay",
  "logoContainer": "MenuHeaderHero-module-scss-module__FQpgjG__logoContainer",
  "menuContainer": "MenuHeaderHero-module-scss-module__FQpgjG__menuContainer",
  "overlay": "MenuHeaderHero-module-scss-module__FQpgjG__overlay",
});
